<div class="row align-items-end mt-2">
	<div class="col col-auto ml-auto" *ngIf="availableMetaItems.length > 0">
		<div *ngIf="editMode" class="btn-group" dropdown>
		  <p dropdownToggle role="button" class="mb-0">
		    <strong>Add metadata <i class="fa fa-angle-down ml-1"></i></strong>
		  </p>
		  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right meta-scroll" role="menu">
		    <li role="menuitem"  *ngFor="let item of availableMetaItems">
		    	<a *ngIf="!item.disabled" class="dropdown-item" (click)="createMetaItem(item)" role="button">
			    	{{item?.name}}
			    </a>
		    </li>
		  </ul>
		</div>
	</div>
</div>
<div class="mb-5 mt-1" *ngIf="item.itemDetail?.metadataItemDetails.length > 0">
	<div class="input-group mb-1" *ngFor="let metaItem of item.itemDetail.metadataItemDetails">
	  <span class="input-group-addon" id="meta-one">
        {{metaItem.name}} &nbsp; <i *ngIf="metaItem.disabled" class="fa fa-warning text-warning" tooltip="This source has been archived. If you remove it you will not be able to re-add it."></i>
      </span>
      <input type="text" class="form-control" (change)="metaChange()" [(ngModel)]="metaItem.value" [ngClass]="{'disabled' : !editMode}" [disabled]="!editMode" placeholder="Please enter reference" aria-label="Source" aria-describedby="meta-one">
	  <span *ngIf="editMode" class="input-group-addon bg-white btn btn-sm" (click)="removeMetaItem(metaItem)"><i class="fa fa-close"></i></span>
	</div>
</div>
